<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.06306 6L10.5349 2.53C10.825 2.24 10.825 1.76 10.5349 1.47C10.2447 1.18 9.76448 1.18 9.47433 1.47L6.0025 4.94L2.53068 1.47C2.24052 1.18 1.76027 1.18 1.47012 1.47C1.17996 1.76 1.17996 2.24 1.47012 2.53L4.94194 6L1.47012 9.47C1.17996 9.76 1.17996 10.24 1.47012 10.53C1.6202 10.68 1.8103 10.75 2.0004 10.75C2.1905 10.75 2.3806 10.68 2.53068 10.53L6.0025 7.06L9.47433 10.53C9.62441 10.68 9.81451 10.75 10.0046 10.75C10.1947 10.75 10.3848 10.68 10.5349 10.53C10.825 10.24 10.825 9.76 10.5349 9.47L7.06306 6Z"
        />
    </svg>
</template>
